import {
    CirclePartner,
    CirclePartnerConfig,
    CircleSponsor,
    CircleSponsorshipUpsertRequest,
    CircleValidationFieldName,
} from '@calm/evexia-web-sdk';

export enum PartnerErrorType {
    Eligibility = 'eligibility_error',
}

export type PartnerValidationFieldsRequest = Partial<
    Record<CircleValidationFieldName, string>
>;

export function getPartnerCircleSponsorshipUpsertRequest(
    partner?: CirclePartner,
    request?: PartnerValidationFieldsRequest
): CircleSponsorshipUpsertRequest {
    const validationFields = partner?.sources.fieldValidation?.validations;
    return validationFields && request
        ? {
              parentPartnerId: partner?.parentPartner?.id,
              validationFields: validationFields.map(({ name }) => {
                  return { name, value: request[name] ?? '' };
              }),
          }
        : {};
}

export function getPartnerErrorConfig(
    partner: CirclePartner,
    errorType: PartnerErrorType
) {
    return partner?.errorConfigs?.find(
        (config) => config.type === (errorType as string)
    );
}

export function getIsRelatedSponsorship(
    currentPartnerId = '',
    currentParentPartnerId = '',
    newPartnerId = ''
) {
    if ((!currentPartnerId && !currentParentPartnerId) || !newPartnerId) {
        return false;
    }

    if (currentParentPartnerId && currentParentPartnerId === newPartnerId) {
        return true;
    }
    return currentPartnerId === newPartnerId;
}

export function getIsPartnerRelatedSponsorship(
    currentPartner?: CirclePartner | CirclePartnerConfig,
    newPartnerId = ''
) {
    return getIsRelatedSponsorship(
        currentPartner?.id,
        currentPartner?.parentPartner?.id,
        newPartnerId
    );
}

export function getIsSponsorRelatedSponsorship(
    currentSponsor?: CircleSponsor,
    newPartnerId = ''
) {
    return getIsRelatedSponsorship(
        currentSponsor?.partnerId,
        currentSponsor?.parentPartnerId,
        newPartnerId
    );
}

/**
 * Only use getPartnerIsOptum()
 */
const OptumPartnerId = '6f79c5c8-d23e-4b27-8a85-afc25c85fcb8';

/**
 * We should work to remove this function wherever it is used and replace with partner portal configuration
 */
export function getPartnerIsOptum(partner: CirclePartner) {
    return partner?.parentPartner?.id === OptumPartnerId;
}
